import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import KeyNumbers from './components/KeyNumbers';
import VisionSection from './components/VisionSection';
import CourtsSection from './components/CourtsSection';
import ActivitiesSection from './components/ActivitiesSection';
import PricingSection from './components/PricingSection';
import AppSection from './components/AppSection';
import NewsSection from './components/NewSection';
import GallerySection from './components/GallerySection';

export default function Home() {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const el = document.getElementById(hash.replace('#', ''));
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 150);
      }
    }
  }, []);

  return (
    <main className="min-h-screen">
      <Navbar />
      <HeroSection />
      <KeyNumbers />
      <VisionSection />
      <CourtsSection />
      <ActivitiesSection />
      <PricingSection />
      <AppSection />
      <NewsSection />
      <GallerySection />
      <Footer />
      {/* Floating Buttons */}
      <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3">
        {/* Call Button */}
        <a
          href="tel:+237687696969"
          className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-500 text-white hover:bg-accent-600 transition-all duration-300 hover:scale-110 cursor-pointer shadow-lg"
          aria-label="Appeler"
        >
          <i className="ri-phone-fill text-2xl md:text-3xl"></i>
        </a>
        {/* WhatsApp Button */}
        <a
          href="https://wa.me/237687696969"
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-[#25D366] text-white hover:bg-[#22c55e] transition-all duration-300 hover:scale-110 cursor-pointer"
          aria-label="Contact WhatsApp"
        >
          <i className="ri-whatsapp-line text-2xl md:text-3xl"></i>
        </a>
      </div>
    </main>
  );
}